import React, { useCallback, useEffect } from "react";
import { alpha, makeStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import { Home, Dashboard, Movie, Forum } from "@material-ui/icons";

import { useHistory, Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useDispatch } from "react-redux";
import { loadBookmark, loadCalendarEvent } from "../../redux/firebaseCalls";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  appbar: {
    backgroundColor: theme.palette.primary.main,
  },
  navbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    color: "inherit",
    "&:hover": {
      cursor: "pointer",
    },
  },
  tabs: {
    margin: "0 10px",
    fontWeight: "700",
    fontSize: "16px",
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
  },
  menuTabs: {
    display: "block",
    // [theme.breakpoints.down("xs")]: {
    //   display: "none",
    // },
  },
  loginDiv: {
    display: "block",
    // [theme.breakpoints.down("xs")]: {
    //   display: "none",
    // },
  },
  inButton: {
    fontWeight: "700",
    marginLeft: 10,
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
  },
  menuButton: {
    display: "none",
    // [theme.breakpoints.down("xs")]: {
    //   display: "block",
    // },
  },
}));

export default function Navbar() {
  const classes = useStyles();
  const { logout, currentUser } = useAuth();
  const history = useHistory();

  // For fetching data from firebase
  const dispatch = useDispatch();
  const userId = currentUser ? currentUser.uid : "";

  const loadData = useCallback(() => {
    loadBookmark(userId, dispatch);
    loadCalendarEvent(userId, dispatch);
  }, [userId, dispatch]);

  useEffect(() => {
    if (currentUser) {
      loadData();
    }
  }, [currentUser, loadData]);

  async function handleLogout() {
    try {
      await logout();
      history.push("/");
    } catch {
      alert("Failed to log out");
    }
  }

  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.appbar}>
        <Container maxWidth="lg">
          <Toolbar className={classes.navbar}>
            <Typography
              variant="h5"
              className={classes.title}
              component={Link}
              to="/"
              underline="none"
              style={{ fontWeight: 700, textDecoration: "none" }}
            >
              GetKampus
            </Typography>
            <div className={classes.menuTabs}>
              <Button
                startIcon={<Home />}
                className={classes.tabs}
                size="large"
                color="inherit"
                component={Link}
                to="/home"
              >
                Home
              </Button>
              {currentUser && (
                <Button
                  startIcon={<Dashboard />}
                  className={classes.tabs}
                  size="large"
                  color="inherit"
                  component={Link}
                  to="/dashboard"
                >
                  Dashboard
                </Button>
              )}
              <Button
                startIcon={<Movie />}
                className={classes.tabs}
                size="large"
                color="inherit"
                component={Link}
                to="/videos"
              >
                Videos
              </Button>
              {currentUser && (
                <Button
                  startIcon={<Forum />}
                  className={classes.tabs}
                  size="large"
                  color="inherit"
                  component={Link}
                  to="/chat"
                >
                  Chat
                </Button>
              )}
            </div>
            <div className={classes.loginDiv}>
              {!currentUser && (
                <Button
                  className={classes.inButton}
                  color="inherit"
                  component={Link}
                  to="/login"
                >
                  Login
                </Button>
              )}
              {!currentUser && (
                <Button
                  className={classes.inButton}
                  color="inherit"
                  component={Link}
                  to="/signup"
                >
                  Signup
                </Button>
              )}
              {currentUser && (
                <Button
                  className={classes.inButton}
                  color="inherit"
                  onClick={handleLogout}
                >
                  Logout
                </Button>
              )}
            </div>
            <div className={classes.menuButton}>
              <IconButton edge="start" color="inherit" aria-label="menu">
                <MenuIcon />
              </IconButton>
            </div>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
}
